import { IRootState } from '../../../store'
import { IServicesBillingConfig } from '../store/configurations.types'

export const getServicesBillingConfigSelector = (state: IRootState): IServicesBillingConfig =>
  state.configurations.servicesBillingConfig
